
import React from 'react';
import {Button, Card, CardBody} from "reactstrap";
import {Link} from "react-router-dom";

import Logo from '../assets/images/logo.png';
import EuFlag from '../assets/images/eu_flag.png';
import { FormattedMessage } from 'react-intl';
import { LanguageSwitcherBasic } from '../i18n';

export default function Landing() {
    return <div className="d-flex flex-row align-items-center justify-content-center home" style={{ minHeight: '100%' }}>
        <div className="intro">
            <img src={Logo} className="logo" alt="Logo" />

            <div>
                <h1>Online Mentoring Platform</h1>
                <h2>for Young SportsTech Enterpreneurs</h2>
            </div>
            
            <div>
                <LanguageSwitcherBasic className="mb-0" />
    
                <Link to="/login"><Button color="primary"><FormattedMessage id="JOIN_NOW" /></Button></Link>
            </div>

            <img src={EuFlag} className="erasmuslogo" alt="Erasmus+" />
        </div>
    </div>
}